<template>
  <div class="container">
    <ul class="uk-subnav uk-subnav-pill" uk-switcher>
      <li><a href="#">available</a></li>
      <li><a href="#">completed</a></li>
      <!-- <li><a href="#">staff</a></li> -->
    </ul>

    <ul class="uk-switcher uk-margin">
        <li>
          <list-assessments></list-assessments>
        </li>
        <li>
          <list-completed-assessments></list-completed-assessments>
        </li>
        <li>staff</li>
    </ul>
  </div>
</template>

<script>
import ListAssessments from '@/components/ListAssessments';
import ListCompletedAssesments from '@/components/ListCompletedAssessments';
export default {
  name: 'Dashboard',
  components: {
    'list-assessments': ListAssessments,
    'list-completed-assessments': ListCompletedAssesments
  }
}
</script>

<style>

</style>